/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { Component, OnInit } from '@angular/core';
import {LicenseService} from '../@shared/_services/license.service';
import {AuthService} from '../@shared/_services/auth.service';
import {Title} from '@angular/platform-browser';
import {UserService} from '../@shared/_services/user.service';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {LiveAnnouncer} from '@angular/cdk/a11y';

@Component({
  selector: 'app-report',
  template: `<ngx-extended-pdf-viewer [src]="downloadLink" useBrowserLocale="true" [filenameForDownload]="pdfName"></ngx-extended-pdf-viewer>`
})
export class ReportComponent implements OnInit {

  pdfName: string;
  downloadLink: any;
  /*licenseEmail: string;*/
  licenseCode: string;
  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private userService: UserService,
    private licenseService: LicenseService,
    private translate: TranslateService,
    private authService: AuthService,
    private liveAnnouncer: LiveAnnouncer
  ) { }

  ngOnInit(): void {
    this.translate.get('app.titles.report').subscribe( (text: string) => {
      this.titleService.setTitle(text + ' | veglegestorles.hu');
      this.liveAnnouncer.announce(text + ' | veglegestorles.hu');
    });
    /*this.userService.purgeAuth();*/
    /*this.licenseEmail = this.route.snapshot.paramMap.get('licenseEmail');*/
    /*this.licenseCode = this.route.snapshot.paramMap.get('licenseCode');*/
    /*this.authService.saveTemporaryAuthorizationCred(JSON.stringify({
      email: this.licenseEmail,
      licenseCode: this.licenseCode
    }));*/
    this.pdfName = 'Certus_Erasure_Report.pdf';
    this.setDownloadLink();
  }

  setDownloadLink(): any {
    this.licenseService.downloadReport().subscribe(res => {
      this.downloadLink = URL.createObjectURL(res);
    });
  }

}
